// frontend/src/presentation/speech/voskModelStore.ts
//
// Malutki store „ostatni znany stan modelu STT offline". Pomost między
// `useDictation` (który zna stan pobierania modelu Vosk) a banerem
// `<OfflineModelBanner/>` w Screen1 — Screen1 jest „zamrożony" wzorcem Strangler,
// więc nie przepychamy stanu przez jego propsy, tylko przez ten kanał boczny.
//
// Wzorzec `useSyncExternalStore`: `subscribe` + `getSnapshot` + imperatywny `set`.

/**
 * Stan modelu offline (Vosk):
 *  - `idle`    — nie tknięty (sesje online nigdy nie ruszą bannera),
 *  - `loading` — pobieranie / inicjalizacja (~50 MB, najlepiej przez WiFi),
 *  - `ready`   — model w pamięci, rozpoznawanie offline dostępne,
 *  - `error`   — pobranie/inicjalizacja nieudane (kolejna próba możliwa).
 */
export type ModelStatus = 'idle' | 'loading' | 'ready' | 'error'

let current: ModelStatus = 'idle'
const listeners = new Set<() => void>()

export const voskModelStore = {
  /** Ustawia stan i budzi subskrybentów (tylko przy realnej zmianie). */
  set(status: ModelStatus): void {
    if (status === current) return
    current = status
    for (const listener of listeners) listener()
  },
  getSnapshot(): ModelStatus {
    return current
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  /** Wyłącznie dla testów — przywraca stan początkowy. */
  _reset(): void {
    current = 'idle'
    listeners.clear()
  },
}
